import { useNavigate } from "react-router-dom";
import { JcCommonProps, JcUtils } from "../../utils/JcUtils";
import { JcClickableText } from "../JcClickableText";
import React from "react";

export interface JcAppTitleTextProps extends JcCommonProps {
    readonly label: string;
    readonly onNavigate: (route: string) => void;
}

export const JcAppTitleText = (props: JcAppTitleTextProps): React.ReactElement => {
    const commonProps = JcUtils.commonProps(props, ["jc-app-title-text"]);
    return <JcClickableText
        {...commonProps}
        onClick={() => props.onNavigate("/")}
        label={props.label} />
}